var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 367,
    viewBox: "0 0 365 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.05
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 288C239.741 288 286 241.358 286 184C286 126.642 239.741 80 182.5 80C125.259 80 79 126.642 79 184C79 241.358 125.259 288 182.5 288Z",
    stroke: "#516CD3",
    strokeWidth: 30
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.05
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 352C275.1 352 350 276.467 350 183.5C350 90.5326 275.1 15 182.5 15C89.9 15 15 90.5326 15 183.5C15 276.467 89.9 352 182.5 352Z",
    stroke: "#516CD3",
    strokeWidth: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing3);
export default __webpack_public_path__ + "static/media/Ring3.b7e18a1acaea764717b386a70362bf9c.svg";
export { ForwardRef as ReactComponent };